module.exports = __webpack_public_path__ + "img/medium-pencil.6196b711.svg";